import React, { Fragment } from "react";
import { connect } from "react-redux";
import MDLoading from "~/components/common/atoms/MDLoading";
import Breadcrumb from "~/components/desktop/atoms/Breadcrumb";
import { redirectToMedproId } from "~/store/login/actions";

const AuthenticationMedpro = ({
  ChildComponent,
  IsAuthenticated,
  breadcrumb,
  redirectToMedproId,
  ...rest
}) => {
  React.useEffect(() => {
    if (!IsAuthenticated) {
      redirectToMedproId({});
    }
  }, [IsAuthenticated, redirectToMedproId]);

  return (
    <Fragment>
      {breadcrumb && <Breadcrumb className="head" />}
      {IsAuthenticated ? <ChildComponent {...rest} /> : <MDLoading />}
    </Fragment>
  );
};

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated }
  } = state;
  return {
    IsAuthenticated
  };
};

export default connect(mapStateToProps, {
  redirectToMedproId
})(AuthenticationMedpro);
